/*
 * Override styles for specific components
 * All available overrides are listed here but set to null
 */

export default {
    dropdownMenu: {
        optionPadding: null
    }
};



// WEBPACK FOOTER //
// ./app/themes/default-theme/overrides.js